import SpsNotification from './SpsNotification';

export {
    SpsNotification
};

export default SpsNotification;
